import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { updateEstimate } from '../../../../../services/ContractService/contractEstimateSlice';
import { StayType } from '../../../../../services/ContractService/types/contractEstimateTypes';

/**
 * EstimateStayTypeEditor Component
 * 
 * Allows users to select between Inpatient (IP) and Outpatient (OP) stay types.
 * This affects the calculation logic in the calculator service.
 */
export const EstimateStayTypeEditor: React.FC = () => {
  const dispatch = useAppDispatch();
  const estimate = useAppSelector(state => state.contractEstimate.currentEstimate);
  const errors = useAppSelector(state => state.contractEstimate.validationErrors);

  const handleStayTypeChange = (event: SelectChangeEvent<StayType>) => {
    dispatch(updateEstimate({
      stayType: event.target.value as StayType
    }));
  };

  // Default to 'OP' if not set
  const currentStayType: StayType = estimate?.stayType || 'OP';

  return (
    <FormControl 
      size="small" 
      sx={{ minWidth: 140 }}
      error={!!errors.stayType}
    >
      <InputLabel id="stay-type-label">Stay Type</InputLabel>
      <Select
        labelId="stay-type-label"
        id="stay-type-select"
        value={currentStayType}
        label="Stay Type"
        onChange={handleStayTypeChange}
      >
        <MenuItem value="OP">Outpatient (OP)</MenuItem>
        <MenuItem value="IP">Inpatient (IP)</MenuItem>
      </Select>
      {errors.stayType && (
        <FormHelperText>{errors.stayType}</FormHelperText>
      )}
    </FormControl>
  );
};
